module.exports = __webpack_public_path__ + "img/ics_o_sort.5e6fc098.svg";